// extracted by mini-css-extract-plugin
module.exports = {"img":"downloadLinks-module--img--25E8H","icon":"downloadLinks-module--icon--36IY4","link":"downloadLinks-module--link--3xZx-","chip":"downloadLinks-module--chip--1MvG8"};